import { render, staticRenderFns } from "./TicketHistory.vue?vue&type=template&id=789e4834&scoped=true&"
import script from "./TicketHistory.vue?vue&type=script&lang=ts&"
export * from "./TicketHistory.vue?vue&type=script&lang=ts&"
import style0 from "./TicketHistory.vue?vue&type=style&index=0&id=789e4834&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789e4834",
  null
  
)

export default component.exports